import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

/**
 * Editable list of "marketing bullet" strings — used by both the
 * Standard and Premium plan cards on the Pricing tab. Pure controlled
 * component: caller owns `value` and gets the whole new array via
 * `onChange`.
 */
export const FeaturesEditor = ({ label, hint, value, onChange, testIdPrefix }) => {
  const items = Array.isArray(value) ? value : [];
  const upd = (i, txt) => onChange(items.map((x, idx) => (idx === i ? txt : x)));
  const rm  = (i)      => onChange(items.filter((_, idx) => idx !== i));
  const add = ()       => onChange([...items, '']);
  return (
    <div className="set-row" style={{ alignItems: 'flex-start' }}>
      <div className="tx"><b>{label}</b><small>{hint}</small></div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flex: 1, maxWidth: 480 }}>
        {items.map((v, i) => (
          <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            <input
              className="inp"
              value={v}
              onChange={(e) => upd(i, e.target.value)}
              placeholder="Feature bullet"
              style={{ flex: 1 }}
              data-testid={`${testIdPrefix}-${i}`}
            />
            <button
              type="button"
              className="btn s"
              onClick={() => rm(i)}
              aria-label={`Remove feature ${i + 1}`}
              data-testid={`${testIdPrefix}-remove-${i}`}
              style={{ padding: '6px 8px' }}
            ><Trash2 size={14} /></button>
          </div>
        ))}
        <button
          type="button"
          className="btn s"
          onClick={add}
          data-testid={`${testIdPrefix}-add`}
          style={{ alignSelf: 'flex-start' }}
        ><Plus size={14} /> Add feature</button>
      </div>
    </div>
  );
};
